import SubmissionError from '../../../../error/SubmissionError'
import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

export const create = ({ commit }, values) => {
  commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_SET_ERROR, '')
  commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_TOGGLE_LOADING)

  const headers = new Headers()
  headers.set('Content-Type', 'application/json')
  headers.set('Accept', 'application/json')

  return fetch(
    'account_settlement_continuations',
    {
      method: 'POST',
      body: JSON.stringify(values),
      headers: headers
    }
  )
    .then((response) => {
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_TOGGLE_LOADING)

      return response.json()
    })
    .then((data) => {
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_SET_CREATED, data)
    })
    .catch((e) => {
      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_TOGGLE_LOADING)

      if (e instanceof SubmissionError) {
        commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_SET_VIOLATIONS, e.errors)
        // eslint-disable-next-line
        commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_SET_ERROR, e.errors._error);

        return
      }

      commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.ACCOUNT_SETTLEMENT_CONTINUATION_CREATE_RESET)
}
